import { globalStyle, style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Styled <table> wrapper. We use globalStyle for the descendant
// thead/tbody/th/td rules so callers can write plain HTML inside —
// no wrapper components needed, no need for each cell to carry a
// class.
export const table = style({
  width: "100%",
  borderCollapse: "collapse",
  fontFamily: vars.font.body,
  fontSize: vars.fontSize.sm,
  color: vars.color.textDefault,
});

globalStyle(`${table} thead th`, {
  textAlign: "left",
  paddingBlock: vars.space.sm,
  paddingInline: vars.space.md,
  borderBottomWidth: "2px",
  borderBottomStyle: "solid",
  borderBottomColor: vars.color.borderSubtle,
  color: vars.color.textMuted,
  fontSize: vars.fontSize.xs,
  fontWeight: vars.fontWeight.semibold,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "transparent",
});

globalStyle(`${table} tbody td`, {
  paddingBlock: vars.space.sm,
  paddingInline: vars.space.md,
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: vars.color.borderSubtle,
  verticalAlign: "top",
});

// Last row has no divider — tidier visual for tables inside Cards.
globalStyle(`${table} tbody tr:last-child td`, {
  borderBottom: "none",
});

// Subtle hover lift for rows — purely presentational, no click handler.
globalStyle(`${table} tbody tr:hover td`, {
  backgroundColor: vars.color.surfaceMuted,
});
